import { auth } from '../config/firebase';

// Waits for Firebase auth to resolve its initial state, then returns
// the current user (or null). Avoids the false-negative window on hard
// page loads before the SDK restores the session.
export const waitForAuthUser = () =>
  new Promise((resolve) => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      unsubscribe();
      resolve(user);
    });
  });

// fetch() against the backend API with the signed-in member's ID token.
// Rejects if nobody is signed in — callers should guard with
// waitForAuthUser() first.
export const authedFetch = async (path, options = {}) => {
  const user = auth.currentUser || (await waitForAuthUser());
  if (!user) {
    throw new Error('Not signed in');
  }

  const idToken = await user.getIdToken();

  return fetch(`${process.env.REACT_APP_BASE_URL}${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(options.headers || {}),
      Authorization: `Bearer ${idToken}`,
    },
  });
};
